/**
 * @desc 单行溢出省略，且tooltip
 * @author caoyx
 * @param 必传：text { text } 处理的文本
 * @example <EllipsisAndTooltip text={text} />
 */
import React from 'react';
import { Tooltip } from 'antd';
import cns from 'classnames';
import { overtopOmit, fieldAnomaly } from '../../../utils/formatter';

export default function EllipsisAndTooltip({ text = '', max, getPopupContainer }) {
    text = fieldAnomaly(text);

    return (
        max && text.length < max ?
            <div>{text}</div> :
            <Tooltip title={text} getPopupContainer={getPopupContainer}>
                <div className={cns(max ? '' : 'text-ellipsis')}>{overtopOmit(max, text)}</div>
            </Tooltip>
    );
}



// WEBPACK FOOTER //
// ./src/components/common/ellipsisAndTooltip/EllipsisAndTooltip.jsx